const activeMenuItem = (elem) => {
  const topMenu = document.querySelector('.wp-custom-block-navigation-primary');
  const sideMenu = document.querySelector(
    '.wp-custom-sidenav.wp-block-page-list'
  );

  // Scour DOM for an active menu item
  if (topMenu) {
    topMenu
      .querySelector('.current-menu-item')
      ?.closest(
        '.wp-block-navigation-item.has-child.wp-block-navigation-submenu'
      )
      ?.classList.add('current-anscestor-item');
  }

  if (topMenu && sideMenu) {
    const menuItemHref = sideMenu
      .querySelector('.current-menu-ancestor')
      ?.querySelector('.wp-block-pages-list__item__link')
      ?.getAttribute('href');

    if (menuItemHref) {
      topMenu
        .querySelector(
          `.wp-block-navigation-item__content[href="${menuItemHref}"]`
        )
        ?.closest(
          '.wp-block-navigation-item.has-child.wp-block-navigation-submenu'
        )
        ?.classList.add('current-anscestor-item');
    }
  }
};

export default activeMenuItem;
